// import {useIntl} from 'react-intl'
// import {PageTitle} from 'layout/master-layout'
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, useNavigate} from 'react-router-dom'
// import {SendOTPAction} from 'redux/slice/sendOtp'
// import {sendAgentOTP} from 'utils/api/auth/sendAgentOTP'
// import {useNavigate} from 'react-router-dom'
// import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
// import Spinner from 'layout/common/Spinner'
import {useAuth} from 'context/AuthProvider'
import {KTImage} from 'helpers/ui-components/KTImage'
import {useTranslation} from 'react-i18next'
import {toAbsoluteImageUrl} from 'utils/helper'
// import {LinkCard} from './LinkCard'
import {Model} from 'helpers/ui-components/Modal'
import {Button} from 'helpers'
import {IFormField} from 'models/Common'
import {setHomePageCardData} from '../../redux/reducer/homePageCardReducer'
import {setHomePageQuickLinkData} from '../../redux/reducer/homePageQuickLinkReducer'
import {setSupportingAppLinkData} from '../../redux/reducer/supportingAppLinkReducer'
import {
 fetchHomePageCard,
 fetchHomePageQuickLinks,
 fetchAupportingAppLinks,
} from 'utils/api/cms/fetchHomePageData'
import {
 IHomePageCard,
 IHomePageQuickLink,
 IHomePageSupportingAppLink,
} from 'models/CMS'
import {LinkCard} from './LinkCard'

// type Props = {}

const HomePage = () => {
 const {userData} = useAuth()
 const navigate = useNavigate()
 const [showDocPendingModel, setShowDocPendingModel] =
  useState(false)
 const [homePageCardList, setHomePageCardList] = useState<
  IHomePageCard[] | null
 >(null)
 const [quickLinkList, setQuickLinkList] = useState<
  IHomePageQuickLink[] | null
 >(null)
 const [supportingAppsList, setSupportingAppsList] =
  useState<IHomePageSupportingAppLink[] | null>(null)
 const [supportingAppsData, setSupportingAppsData] =
  useState<IHomePageSupportingAppLink | null>(null)
 const dispatch = useDispatch()
 const {t} = useTranslation()
 const homePageCardReducer = useSelector(
  (state: IFormField) => state?.homePageCardReducer
 )

 const homePageQuickLinkReducer = useSelector(
  (state: IFormField) => state?.homePageQuickLinkReducer
 )

 const supportingAppLinkReducer = useSelector(
  (state: IFormField) => state?.supportingAppLinkReducer
 )

 const quickCards = [
  {
   title: 'Tutorials',
   icon: (
    <KTImage src='/media/img/home/yt.png' alt='Tutorials' />
   ),
   onClick: () => {
    navigate('/tutorials')
   },
  },
 ]

 const getHomePageCardData = async () => {
  if (userData) {
   const response: IHomePageCard[] | null =
    await fetchHomePageCard(
     userData.userCategoryKey,
     userData?.selectedLanguage
    )
   if (response) dispatch(setHomePageCardData(response))
  }
 }

 useEffect(() => {
  if (homePageCardReducer?.status === 'idle') {
   void getHomePageCardData()
  } else {
   if (homePageCardReducer?.data)
    setHomePageCardList(homePageCardReducer.data)
  }
 }, [homePageCardReducer])

 const getHomePageQuickLinks = async () => {
  if (userData) {
   const response: IHomePageQuickLink[] | null =
    await fetchHomePageQuickLinks(
     userData.userCategoryKey,
     userData?.selectedLanguage
    )
   if (response)
    dispatch(setHomePageQuickLinkData(response))
  }
 }

 useEffect(() => {
  if (homePageQuickLinkReducer?.status === 'idle') {
   void getHomePageQuickLinks()
  } else {
   if (homePageQuickLinkReducer?.data)
    setQuickLinkList(homePageQuickLinkReducer.data)
  }
 }, [homePageQuickLinkReducer])

 const getSupportingAppLinks = async () => {
  if (userData) {
   const response: IHomePageSupportingAppLink[] | null =
    await fetchAupportingAppLinks(
     userData.userCategoryKey,
     userData?.selectedLanguage
    )
   if (response)
    dispatch(setSupportingAppLinkData(response))
  }
 }

 useEffect(() => {
  if (supportingAppLinkReducer?.status === 'idle') {
   void getSupportingAppLinks()
  } else {
   if (supportingAppLinkReducer?.data)
    setSupportingAppsList(supportingAppLinkReducer.data)
  }
 }, [supportingAppLinkReducer])

 useEffect(() => {
  setShowDocPendingModel(false)
 }, [userData])

 return (
  <div className='container'>
   <Model
    show={supportingAppsData ? true : false}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 bg-[#E6EBF0] rounded-3xl w-7 h-7'
    header={''}
    close={() => {
     setSupportingAppsData(null)
    }}
    modelClass='md:w-[810px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-12'
   >
    <div className='flex justify-between'>
     <KTImage
      className={'w-[238px] h-[238px]'}
      src={supportingAppsData?.QrCode?.url}
      alt='QR Code'
     />
     <div className='ml-7 grow-[100]'>
      <p className='text-[#2667BB] font-bold text-xl'>
       {supportingAppsData?.Title}
      </p>
      <p className='text-black font-normal text-sm mt-3'>
       {supportingAppsData?.Description}
      </p>
      {supportingAppsData?.Link && (
       <Link to={supportingAppsData.Link} target={'_blank'}>
        <KTImage
         className={'w-[140px] h-[40px] mt-3'}
         src={supportingAppsData?.StoreIcon?.url}
         alt='Google Play Store'
        />
       </Link>
      )}
     </div>
    </div>
   </Model>
   <Model
    show={showDocPendingModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 bg-[#E6EBF0] rounded-3xl w-7 h-7 hidden'
    header={''}
    close={() => {
     setShowDocPendingModel(false)
    }}
    modelClass='md:w-[644px]'
    modelContainerClass='!rounded-3xl p-10'
    modelBodyClass=''
   >
    <div className='w-full'>
     <div className='w-full text-center items-center'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {t('homePage.docPendingHeader')}
      </p>
      <div className='flex justify-center items-center mt-7'>
       <KTImage
        className={'w-[160px] h-[145px]'}
        src='/media/img/home/doc-pending.png'
        alt='QR Code'
       />
      </div>

      <p className='text-[#33393D] font-medium text-xl mt-3 mt-7'>
       {t('homePage.docPendingBodyText')}
      </p>
      <div className='md:flex items-center justify-center mt-7'>
       <Button
        onClick={() => window.open('/login', '_self')}
        color='blue'
        className='text-center w-full py-[9px] px-[24px] bg-[#4E83E4] 
                        !rounded-lg !text-base text-white font-semibold'
       >
        {t('homePage.docPendingBtn')}
       </Button>
      </div>
     </div>
    </div>
   </Model>
   <div className='w-full bg-white sm:pb-12 md:pb-28'>
    <div
     className='curve w-full bg-[#264886] bg-center bg-no-repeat bg-blend-soft-light'
     style={{
      backgroundImage: `url(${toAbsoluteImageUrl(
       '/media/img/home/banner.png'
      )})`,
     }}
    >
     <div
      className={`md:flex justify-center m-auto justify-items-center md:h-[598px] md:pt-[100px]`}
     >
      {homePageCardList?.map(
       (val: IHomePageCard, key: number) => (
        <Link
         key={key}
         to={val?.PageUrl ?? '#'}
         target={`${val.OpenInNewTab ? '_blank' : '_self'}`}
         className='slide m-[12px] relative text-center w-[260px] h-[250px] bg-gradient-to-r from-[#079CB0] via-[#3ECDE0] to-[#85D8F2] rounded-[20px]'
        >
         <div
          className='p-[24px] text-center rounded-t-[15px] w-full h-[204px] curve-box-bg bg-red'
          style={{
           backgroundImage: `url(${toAbsoluteImageUrl(
            val.BackgroundImage?.url
           )})`,
          }}
         >
          <div className='w-[120px] h-[120px] m-auto rounded-full bg-white flex items-center justify-center'>
           <KTImage
            width={82}
            height={82}
            className={'flex'}
            src={val.Icon?.url}
            alt={val.Title}
           />
           {/* <ImageAttr src={data.attributes?.Image?.url} title={data.attributes?.Image?.name} className="" /> */}
          </div>
          {/* <h3 className='mt-2 text-sm font-semibold text-[#101010]'>
           {val.Title}
          </h3>
          <p className='mt-2 text-xs font-normal text-white'>
           {val.Description}
          </p> */}
         </div>
         <p className='w-full text-base font-semibold text-[#4E83E4] text-center py-3 cursor-pointer bg-white rounded-b-[20px]'>
          {val?.BtnLabel}
         </p>
        </Link>
       )
      )}
     </div>
    </div>
    <div className='f-full pt-12'>
     {supportingAppsList &&
      supportingAppsList?.length > 0 && (
       <div className='pt-12'>
        <p className='w-full text-2xl font-bold text-[#4D4D4D] text-center'>
         {t('homePage.supportingAppLink')}
        </p>
        <div
         className={`md:flex justify-center m-auto justify-items-center md:pt-3`}
        >
         {supportingAppsList?.map(
          (
           val: IHomePageSupportingAppLink,
           key: number
          ) => (
           <LinkCard
            key={key}
            onClick={() => {
             setSupportingAppsData(val)
            }}
            imageUrl={val.Icon?.url}
            imageAlt={val.Title}
            buttonText={val.BtnLabel}
           />
          )
         )}
        </div>
       </div>
      )}
     {quickLinkList && quickLinkList?.length > 0 && (
      <div className='pt-12'>
       <p className='w-full text-2xl font-bold text-[#4D4D4D] text-center'>
        {t('homePage.quickLink')}
       </p>
       <div
        className={`md:flex justify-center m-auto justify-items-center md:pt-3`}
       >
        {quickLinkList?.map(
         (val: IHomePageQuickLink, key: number) => (
          <Link
           key={key}
           to={val?.Link ?? '#'}
           target={`${
            val.OpenInNewTab ? '_blank' : '_self'
           }`}
          >
           <LinkCard
            imageUrl={val.Icon?.url}
            imageAlt={val.Title}
            buttonText={val.Title}
           />
          </Link>
         )
        )}
       </div>
      </div>
     )}
    </div>
    <div className='pt-12'>
     {/* <p className='w-full text-2xl font-bold text-[#4D4D4D] text-center'>
      Quick Links
     </p> */}

     <div className='flex justify-center gap-6 mt-6 flex-wrap'>
      {quickCards.map((card, index) => (
       <div
        key={index}
        className='w-[260px] flex-shrink-0 border rounded-xl shadow-sm bg-white hover:shadow-md cursor-pointer transition p-4'
        onClick={card.onClick}
       >
        <div className='flex justify-center items-center bg-[#F5F8FA] p-6 rounded-lg mb-4'>
         {card.icon}
        </div>

        <p className='text-center text-[18px] font-medium text-[#4D4D4D]'>
         {card.title}
        </p>
       </div>
      ))}
     </div>
    </div>
   </div>
  </div>
 )
}

export default function HomePageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 return (
  <>
   {/* <PageTitle
        breadcrumbs={[{title: 'sdf', path: 'login', isActive: false}]}
        description='Home'
      >
        Home Page
      </PageTitle> */}
   <HomePage />
  </>
 )
}
